import Glide from '@glidejs/glide/dist/glide.min';
function sliderCarousel(id, num, b3, b2, b1) {
    var slide = document.getElementById(id);
    if (slide) {
        var instanceSlider = new Glide(slide, {
            type: 'carousel',
            gap: 0,
            perView: num,
            breakpoints: {
                991: {
                    perView: b3
                },
                767: {
                    perView: b2
                },
                575: {
                    perView: b1
                }
            }
            // focusAt: 'left'
        });
        var arrowNextSlides = document.getElementById('arrowNext-slides_'+id);
        var arrowPrevSlides = document.getElementById('arrowPrev-slides_'+id);

        arrowNextSlides.addEventListener('click', function() {
            instanceSlider.go('>');
            // hideCarrDesc();
        });

        arrowPrevSlides.addEventListener('click', function() {
            instanceSlider.go('<');
            // hideCarrDesc();
        });

        instanceSlider.mount();

        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
            instanceSlider.update();
        })
    }
}

$(document).ready(function() {
    sliderCarousel('lugares', 2, 2, 2, 1 );
    sliderCarousel('vinillos', 5, 3, 2, 1 );
    sliderCarousel('productos', 4, 2, 2, 1);
    sliderCarousel('ficha_lugar', 5, 3, 2, 1);
    sliderCarousel('proximos_eventos', 4, 2, 2, 1 );
});